import ToggleSwitch from "../../atoms/ToogleSwitch";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Loading from '../../ions/Loading';
import PageList from '../../templates/PageList';
import ReprocessForm from "./ReprocessForm";
import { Auth } from "aws-amplify";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_CONTRACT_REGISTER_API_URL;
const DISBURSEMENT_ACTIVE_PROPERTY = 'dimensa_disbursement_register_enabled';
const SETTLEMENT_ACTIVE_PROPERTY = 'dimensa_settle_register_enabled';

type BusinessProperties = {
    key: string;
    value: boolean;
};

const ContractDisbursementList = () => {

    const navigate = useNavigate();

    const [activeDisbursement, setActiveDisbursement] = useState(false);
    const [activeSettlement, setActiveSettlement] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const token = useRef('');

    useEffect(() => {
        Auth.currentSession()
            .then((user) => user.getIdToken().getJwtToken())
            .then((tkn) => {
                token.current = tkn;
                fetchData(tkn);
            })
            .catch((error) => {
                navigate("/denied");
                console.error('Error during authentication:', error);
            });
    }, []);

    const fetchData = async (token: string) => {
        try {
            const [responseDisbursement, responseSettlement] = await Promise.all([
                apiGet(`${BASE_URL}/maintenance/variables/value/${DISBURSEMENT_ACTIVE_PROPERTY}`, token),
                apiGet(`${BASE_URL}/maintenance/variables/value/${SETTLEMENT_ACTIVE_PROPERTY}`, token)
            ]);

            if (responseDisbursement && responseSettlement) {
                const respDisb: BusinessProperties = await responseDisbursement.json();
                const respSettle: BusinessProperties = await responseSettlement.json();
                setActiveDisbursement(respDisb.value);
                setActiveSettlement(respSettle.value);
            }
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const apiGet = async (url: string, token: string) => {
        try {
            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error('Network response was not ok');
            return response;
        } catch (error) {
            navigate('/network-error');
            console.error('Error fetching data:', error);
        }
    };

    const handleToggle = async (type: string, status: boolean) => {
        if (![DISBURSEMENT_ACTIVE_PROPERTY, SETTLEMENT_ACTIVE_PROPERTY].includes(type)) {
            throw new Error('Invalid type');
        }
        const url = `${BASE_URL}/maintenance/variables/${type}/${status}`;
        try {
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token.current}`
                },
                mode: 'cors'
            });

            if (!response.ok) throw new Error('Network response was not ok');


            toast.info("Ação realizada com sucesso!");


            if (type === DISBURSEMENT_ACTIVE_PROPERTY)
                setActiveDisbursement(status);
            else if (type === SETTLEMENT_ACTIVE_PROPERTY)
                setActiveSettlement(status);

        } catch (error) {

            toast.error('Erro ao realizar ação');

            console.error('Error:', error);
        }
    };

    if (isLoading) {
        return <Loading />;
    }
    return (
        <div className="w-full max-w-5xl mx-auto px-2 sm:px-6 lg:px-8 py-8">
            <nav className="mb-4 flex text-sm text-gray-500 gap-2">
                <span className="hover:underline cursor-pointer">Financeiro</span>
                <span className="mx-1">/</span>
                <span className="font-semibold text-teal-700">Configuração de APIs</span>
            </nav>
            <h1 className="text-2xl sm:text-3xl font-bold text-teal-700 tracking-tight mb-2">Configuração de APIs Financeiras</h1>
            <p className="text-gray-500 mb-8 text-base sm:text-lg">Gerencie o status das integrações Dimensa de Desembolso e Liquidação.</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 flex flex-col justify-between">
                    <div className="flex items-center justify-between mb-4">
                        <div>
                            <h2 className="text-lg font-semibold text-gray-800">Desembolso</h2>
                            <p className="text-xs text-gray-500">Ative ou desative a API de registro de desembolso.</p>
                        </div>
                        <ToggleSwitch
                            checked={activeDisbursement}
                            onChange={() => handleToggle(DISBURSEMENT_ACTIVE_PROPERTY, !activeDisbursement)}
                        />
                    </div>
                    <span className={`text-xs font-semibold ${activeDisbursement ? "text-green-600" : "text-red-500"}`}>
                        {activeDisbursement ? 'API Ligada' : 'API Desligada'}
                    </span>
                </div>
                <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 flex flex-col justify-between">
                    <div className="flex items-center justify-between mb-4">
                        <div>
                            <h2 className="text-lg font-semibold text-gray-800">Liquidação</h2>
                            <p className="text-xs text-gray-500">Ative ou desative a API de registro de liquidação.</p>
                        </div>
                        <ToggleSwitch
                            checked={activeSettlement}
                            onChange={() => handleToggle(SETTLEMENT_ACTIVE_PROPERTY, !activeSettlement)}
                        />
                    </div>
                    <span className={`text-xs font-semibold ${activeSettlement ? "text-green-600" : "text-red-500"}`}>
                        {activeSettlement ? 'API Ligada' : 'API Desligada'}
                    </span>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 mt-2">
                <h2 className="text-lg font-semibold text-gray-800 mb-2">Desembolsos - envio manual</h2>
                <p className="text-xs text-gray-500 mb-4">Utilize o formulário abaixo para reprocessar desembolsos manualmente.</p>
                <ReprocessForm token={token.current} />
            </div>
        </div>
    );
};

export default ContractDisbursementList;
